import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d50fd70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "studentRecord" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "研究生回访计划表", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新建计划")
const _hoisted_6 = {
  class: "table",
  cellspacing: "0",
  cellpadding: "0",
  style: { display: 'flex', maxWidth: '1001px', 'flex-wrap': 'wrap' }
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "日期", -1))
const _hoisted_9 = { class: "option" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "学生回访计划表", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("新建计划")
const _hoisted_15 = {
  class: "table",
  cellspacing: "0",
  cellpadding: "0",
  style: { display: 'flex', maxWidth: '1001px', 'flex-wrap': 'wrap'}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "日期", -1))
const _hoisted_18 = { class: "option" }
const _hoisted_19 = { class: "date" }
const _hoisted_20 = ["onClick"]

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getVisitList } from "../../config/interface";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
let back = "<";
// 接口返回数据，包括学生上课记录和研究生上课记录
const returnInfo = ref({
  planList: [
    {
      date: "",
    }],
});
// 点击返回到上一页
const handleBack = () => {
  router.back();
};
const handleShowEdit = (item: any) => {
  let temp = JSON.stringify(item);
  router.push({
    name: "PlanEdit",
    params: {
      info: temp,
    },
  });
};
// 研究生新建回访计划
const toCreatePlan = () => {
  router.push({
    path: "/order/createPlan",
    query: { coId: route.query.coId, type: 2 },
  });
};
// 学生新建回访计划
const toCreatePlan2 = () => {
  router.push({
    path: "/order/createPlan",
    query: { coId: route.query.coId, type: 1 },
  });
};
// 挂载生命周期，接收订单id，根据订单id查询学生和研究生上课记录
onMounted(() => {
  console.log(route.query);
  getVisitList({ coId: route.query.coId }).then((res) => {
    console.log(res);
    returnInfo.value = res.data.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_el_button, {
        style: {"margin-left":"20px"},
        type: "primary",
        size: "small",
        onClick: toCreatePlan
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("table", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.posPlans, (item, index) => {
        return (_openBlock(), _createElementBlock("tbody", {
          key: index,
          style: { width: '200px' }
        }, [
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, "回访计划" + _toDisplayString(index + 1), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.visitDay), 1),
                _createElementVNode("div", {
                  class: "btn",
                  onClick: ($event: any) => (handleShowEdit(item))
                }, "修改", 8, _hoisted_11)
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_el_button, {
        style: {"margin-left":"20px"},
        type: "primary",
        size: "small",
        onClick: toCreatePlan2
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      })
    ]),
    _createElementVNode("table", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.stuPlans, (item, index) => {
        return (_openBlock(), _createElementBlock("tbody", {
          key: index,
          style: { width: '200px' }
        }, [
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("td", null, "回访计划" + _toDisplayString(index + 1), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(item.visitDay), 1),
                _createElementVNode("div", {
                  class: "btn",
                  onClick: ($event: any) => (handleShowEdit(item))
                }, "修改", 8, _hoisted_20)
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})